/**
 * What the attendee agenda's Join does, in one place so the table, the day
 * view and a `?session=` deep link cannot drift apart. `window.joinSessionEvent`
 * is EventChat's; EventChat clears the scroll lock when the room closes.
 * Attendance is not logged here: the room logs it once the person is in
 * (XN-4644 AC 8), so a click that stops at the pre-join screen does not count.
 */
export const joinFromAgenda = async (eventData) => {
  const joined = window.joinSessionEvent(eventData);
  window.haveSessionEventStarted = true;
  window.eventMinimizeBox?.('boxAgenda');
  document.body.style.overflow = 'hidden';
  return joined;
};
